export enum DigitalContactStatusAgent {
  NEW = 'new', //nova iteração de atendimento
  ESCALATED = 'escalated',
  OPEN = 'open', //quando o cliente respondeu e aguarda o agente responder
  PENDING = 'pending', //Ao enviar mensagem para cliente e fica aguardando resposta
  CLOSED = 'closed', //Ao finalizar o atendimento via chat
  RESOLVED = 'resolved',
  INCOMING = 'incoming',
  DRAFT = 'draft',
}
